import { apiUrl }  from "../constants";
var axios = require('axios');
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':localStorage.getItem('token'),'Content-Type':'application/json'}
})
export default class TeamsApi {
    static getAll(offset = 0, page = 30) {
        return request.get(`/teams/${localStorage.getItem("rol")}/all/${offset}/${page}`);
    }

    static countAll(tournament = null, league = null) {
        return request.get(`/teams/countAll/${tournament}/${league}`);
    }

    static getAvailable() {
        return request.get(`/teams/avaliable/${localStorage.getItem("rol")}?status=1`);
    }

    static get(id) {
        return request.get(`/teams/${localStorage.getItem("rol")}/${id}`);
    }

    static getTeamLeagueStats(team_id, league_id){
        return request.get(`/teams/stats/${localStorage.getItem("rol")}?team=${team_id}&league=${league_id}&sheet=all`);
    }

    // static getAllByLeagues(id) {
    //     return request.get(`/teams/getByLeagues/${localStorage.getItem("rol")}/`+id);
    // }

    static create(team) {
        return request.post('/teams',{team: team });
    }

    static edit(team, id){
        return request.put(`/teams/${id}`, {team: team});
    }

    static delete(team){
        return request.delete(`teams?team_id=${team.id}&league_id=${team.league_id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/Teams.js